import { useEffect, useState } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { FlaskConical } from "lucide-react"
import * as outreachApi from "../api/outreach.api"
import type { ArmResults } from "../types/outreach.types"
import { ArmResultsTable } from "./ArmResultsTable"

/** Consent reminder A/B results per arm: GET /outreach/org/{org}/campaigns/{id}/arms */
export function ReminderArms({ orgId, campaignId, refreshKey }: { orgId: string; campaignId: string; refreshKey?: number }) {
  const [results, setResults] = useState<ArmResults | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setError(null)
    outreachApi
      .getCampaignArms(orgId, campaignId)
      .then((r) => !cancelled && setResults(r))
      .catch((err) => !cancelled && setError(outreachApi.errorMessage(err)))
    return () => {
      cancelled = true
    }
  }, [orgId, campaignId, refreshKey])

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <FlaskConical className="h-4 w-4" />
          Reminder text A/B
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {error ? (
          <p className="text-sm text-muted-foreground">Results unavailable: {error}</p>
        ) : !results ? (
          <Skeleton className="h-24" />
        ) : (
          <ArmResultsTable results={results} />
        )}
      </CardContent>
    </Card>
  )
}
